/* eslint-disable */

export function getStatementForDateRange(name: string, from: string, to: string): string {
	const fromStatement = from ? `${name}=ge=${from}` : null;
	const toStatement = to ? `${name}=le=${to}` : null;
	return statementCombine(fromStatement, toStatement);
}

export function getStatementForFullDateRange(name: string, from: string, to: string): string {
	const fromStatement = from ? `${name}=ge=${from}T00:00:00` : null;
	const toStatement = to ? `${name}=le=${to}T23:59:59` : null;
	return statementCombine(fromStatement, toStatement);
}

export function getStatementForFullDate(name: string, formattedDate: string): string {
	if (formattedDate) {
		return `${name}=ge=${formattedDate}T00:00:00;${name}=le=${formattedDate}T23:59:59`;
	} else {
		return '';
	}
}

export function getGraterThanStatement(name: string, value: any = 0): string {
	return value ? `${name}=ge=${value}` : '';
}

export function getLessThanStatement(name: string, value: any = 0): string {
	return value ? `${name}=le=${value}` : '';
}

export function getStatementForRange(name: string, first: number, last: number): string {
	return statementCombine(first ? `${name}=ge=${first}` : null, last ? `${name}=le=${last}` : null);
}

export function getEqualStatement(name: string, value: any): string {
	if (value !== null && value !== undefined && value !== '') {
		if (typeof value === 'string') {
			return `${name}=='${value}'`;
		} else {
			return `${name}==${value}`;
		}
	} else {
		return '';
	}
}

export function getNotEqualStatement(key: string, value: any) {
	if (typeof value === 'string') {
		return `${key}!='${value}'`;
	} else {
		return `${key}!=${value}`;
	}
}

export function getNullStatement(name: string) {
	return `${name}=null=true`;
}

export function getNotNullStatement(name: string) {
	return `${name}=nnull=true`;
}

export function getLikeStatement(name: string, value: any): string {
	if (value !== null && value !== undefined && value !== '') {
		if (typeof value === 'string') {
			return `${name}=like='${value}'`;
		} else {
			return `${name}=like=${value}`;
		}
	} else {
		return '';
	}
}

export function getInStatement(name: string, values: any): string {
	if (values && values.length > 0) {
		values = values?.map((elem: any) => `'${elem}'`);
		values = `(${values?.join(',')})`;
		return `${name}=in=${values}`;
	} else {
		return '';
	}
}

export function getNotInStatement(name: string, values: any): string {
	if (values && values.length > 0) {
		values = values?.map((elem) => `'${elem}'`);
		values = `(${values?.join(',')})`;
		return `${name}=out=${values}`;
	} else {
		return '';
	}
}

export function addGroup(...statement: string[]) {
	return `(${statement})`;
}

export function getSearchHolder(...statement: string[]) {
	return {
		searchCriteriaOptions: {
			rsqlQueryString: statementCombine(...statement),
		},
	};
}

const searchInit = getSearchHolder;

export function statementCombine(...query: (string | null)[]): string {
	return query.filter((s) => s).join(';');
}

export function statementOrCombine(...query: string[]): string {
	return query.filter((s) => s).join(',');
}

export const rsql = {
	getStatementForDateRange,
	getStatementForFullDateRange,
	getStatementForFullDate,
	getEqualStatement,
	getGraterThanStatement,
	getLessThanStatement,
	getSearchHolder,
	statementCombine,
	statementOrCombine,
	getNotEqualStatement,
	getStatementForRange,
	searchInit,
	getLikeStatement,
	getInStatement,
	getNotInStatement,
	getNullStatement,
	getNotNullStatement,
	addGroup,
};
